import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getRequest, putRequest, patchRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import backBtn from "../../assets/images/back-arrow.svg";
import {
  Button,
  Divider,
  Modal,
  Spin,
  Rate,
  Input,
  Select,
  Switch,
  Tooltip
} from "antd";
import Preview from "../Preview/preview";
import "./orgDetailsPage.scss";
import "./rearrange-drag.scss";
import { toast } from "react-toastify";
import { inputFieldCharLimit } from "../../config";
import { getMicrositeUrl } from "../../utils/helper";
import { useStore } from "../../store";

const truncate = (text, length = 35) => {
  if (text.length < length) {
    return text
  }
  const newText = `${text.slice(0, length)}...`
  return newText
}

export default function OrgDetailsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [org, setOrg] = useState();

  const orgType = location.state.orgType;
    const partnername = sessionStorage.getItem("OrgName");

  const [nameEditing, setNameEditing] = useState(false);
  const [newOrgName, setNewOrgName] = useState('');

  const [typeEditing, setTypeEditing] = useState(false);
  const [orgName, setOrgName] = useState();
  const [orgTypeName, setOrgTypeName] = useState();
  const [allOrgTypes, setAllOrgTypes] = useState([]);
  const [selectedOrgType, setSelectedOrgType] = useState();

  const [microsites, setMicrosites] = useState();

  const [publishConfirmationModal, setPublishConfirmationModal] =
    useState(false);
  const [unpublishConfirmationModal, setUnpublishConfirmationModal] =
    useState(false);
  const [micrositeId, setMicrositeId] = useState();

  const [reviews, setReviews] = useState();

  const [selectedMicrositeId, setSelectedMicrositeId] = useState();
  const [previewModal, setPreviewModal] = useState(false);
  const partnerID = sessionStorage.getItem("partnerId");

  const [loadingOrgDetails, setLoadingOrgDetails] = useState(true)
  const [micrositesLoading, setMicrositesLoading] = useState(true);
  const [loadingReviews, setLoadingReviews] = useState(true)
  const [loadingMemberSwitch, setLoadingMemberSwitch] = useState(false)

  const {tabInterestName} = useStore()
  const getMicrositesData = async (orgId) => {
    setMicrositesLoading(true);
    try {
      const response = await getRequest(
        userServiceApi.getMicrositesByOrganization(orgId)
      );
      if (response) {
        setMicrosites(response.data);
      }
    } catch (error) {
      toast.error(error.error);
    }
    finally {
      setMicrositesLoading(false)
    }
  };

  const getOnOrganisationType = async () => {
    try {
      const response = await getRequest(
        userServiceApi.getOnOrganisationType(partnerID, "ORGANIZATION_TYPE")
      );
      if (response) {
        // console.log('getOnOrganisationType response ', response)
        setAllOrgTypes(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getOrgReviews = async (id) => {
    setLoadingReviews(true)
    try {
      const res = await getRequest(userServiceApi.getOrgReviews(id));
      if (res) {
        setReviews(res.data);
      }
    } catch (error) {
      console.log();
    }
    finally {
      setLoadingReviews(false)
    }
  };

  useEffect(() => {
    fetchOneOrganizationDetails()
    getMicrositesData(location.state.org.id);
    getOrgReviews(location.state.org.id);
    getOnOrganisationType()
    // Mount-only fetch; handlers are recreated each render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setOrgName(org?.name || '')
    setOrgTypeName(org?.type || '')
    setSelectedOrgType(org?.typeId || '')
  }, [org])

  const unPublishMicrosite = async (option) => {
    try {
      const res = await patchRequest(
        userServiceApi.publishUnpublishMicrosite(micrositeId)
      );
      if (res) {
        console.log("res", res);
        if (option === "publish") {
          toast.success("Site published successfully");
          setPublishConfirmationModal(false);
        } else {
          toast.success("Site unpublished successfully");
          setUnpublishConfirmationModal(false);
        }
        setMicrositeId();
        getMicrositesData(location.state.org.id);
      }
    } catch (error) { }
  };

  const handlePublish = (microsite) => {
    // console.log("microsite.id", microsite.id)
    setPublishConfirmationModal(true);
    setMicrositeId(microsite.id);
  };

  const handleUnpublish = (microsite) => {
    // console.log("microsite.id", microsite.id)
    setUnpublishConfirmationModal(true);
    setMicrositeId(microsite.id);
  };

  const RemoveMicrosite = () => {
    setPreviewModal(false);
    setSelectedMicrositeId();
  };

  const handleNameEditCancel = () => {
    setNameEditing(false);
    setNewOrgName('')
  };

  const handleNameEditSave = async () => {
    setNameEditing(false);

    try {
      const response = await putRequest(
        userServiceApi.updateOneOrganisationData(org.id, newOrgName)
      );
      if (response) {
        setOrgName(response.name);
        toast.success("Successfully updated data.");
        fetchOneOrganizationDetails()
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleTypeEditCancel = () => {
    setTypeEditing(false);
  };

  const handleTypeEditSave = async () => {
    setTypeEditing(false);
    console.log("orgtypee selcted", selectedOrgType);
    try {
      const response = await putRequest(
        userServiceApi.updateOneOrganisationData(org.id, "", selectedOrgType)
      );
      if (response) {
        // console.log("res", response)
        setOrgTypeName(response.type);
        toast.success("Successfully updated data.");
        fetchOneOrganizationDetails()
      }
    } catch (error) {
      console.error(error);
    }
  };

  const formatDate = (reviewDate) => {
    const dateString = reviewDate;
    const date = new Date(dateString);
    const formattedDate = `${date.getDate()}-${date.getMonth() + 1
      }-${date.getFullYear()}`;
    return formattedDate;
  };


  const fetchOneOrganizationDetails = async () => {
    setLoadingOrgDetails(true)
    try {
      const res = await getRequest(userServiceApi.getOneOrganization(location.state.org.id))
      if (res) {

        setOrg(res.data)
      }
    } catch (error) {
      console.log('Error refetching data', error);
    }
    finally {
      setLoadingOrgDetails(false)
      setLoadingMemberSwitch(false)
    }
  }

  const toggleMemberType = async (toggle) => {
    setLoadingMemberSwitch(true)
    try {
      const res = await patchRequest(userServiceApi.updateMemberType(org.id, !toggle))
      if (!res.error) {
        toast.success(`Successfully switched to ${toggle ? 'Hub member' : 'Full member'}`)
      }
      fetchOneOrganizationDetails()
    } catch (error) {
      toast.error(toggle ? 'Failed switching to hub member' : 'Failed switching to full member')
    }
  };
  return (
    <>
      <div className="tabContainer">
        <div className="main-container" style={{ paddingTop: "5px" }}>
          <div className="header-container">
            <div className="backbtn-container">
              <img
                src={backBtn}
                onClick={() => {
                  orgType === "full-member"
                    ? navigate("/full-members")
                    : navigate("/hub-members");
                }}
                alt=""
              />
              {nameEditing ? (
                <Input
                  className="edit-org-name-input"
                  defaultValue={orgName}
                  type="text"
                  value={newOrgName}
                  onChange={(e) => setNewOrgName(e.target.value)}
                  maxLength={inputFieldCharLimit}
                />
              ) : (
                <p style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "500px",
                  whiteSpace: "nowrap",
                }} >{orgName}</p>
              )}
              {!nameEditing ? (
                <Button
                  className="redBtn edit-name-btn"
                  style={{ marginLeft: "20px" }}
                  onClick={() => { setNameEditing(true); setNewOrgName(org.name) }}
                >
                  Edit name
                </Button>
              ) : (
                <>
                  <Button
                    className="form-cancel-btn edit-name-btn first-btn"
                    onClick={handleNameEditCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="redBtn edit-name-btn"
                    onClick={handleNameEditSave}
                    disabled={newOrgName === ''}
                  >
                    Save
                  </Button>
                </>
              )}
            </div>
          </div>
          {loadingOrgDetails ? <div className="data-loader" style={{ marginTop: "0px" }}>
            <Spin className="spin" tip="Loading" size="large" />
          </div> : <div className="org-details2">
            <div className="orgDetails">
              <div className="orgDetailsRow">
                <div className="orgDetailsCol">
                  <div className="orgInfoRow">
                    <div className="orgInfoCol"><label>Type:</label></div>
                    <div className="orgInfoCol">
                      <div className="orgInfoEdit">
                        {typeEditing ? (
                          <div className="orgInfoEditvalue" >
                            <Select
                              className="edit-org-name-select"
                              placeholder="Select Partner Type"
                              value={selectedOrgType?.displayName}
                              onChange={(e) => {
                                setSelectedOrgType(e);
                                // setOrgTypeName(e);
                              }}
                            >
                              {allOrgTypes?.map((type, i) => (
                                <Select.Option key={i} value={type.id}>
                                  {type?.displayName}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : (
                          <div className="orgInfoEditvalue" >
                            <p>{orgTypeName ? orgTypeName : ""}</p>
                          </div>
                        )}
                        {!typeEditing ? (
                          <div className="orgInfoEditvalue" >
                            <Button
                              className="redBtn edit-name-btn"
                              onClick={() => setTypeEditing(true)}
                            >
                              Edit type
                            </Button>
                          </div>
                        ) : (
                          <div className="orgInfoEditvalue" >
                            <Button
                              className="form-cancel-btn edit-name-btn"
                              onClick={handleTypeEditCancel}
                            >
                              Cancel
                            </Button>
                            <Button
                              className="redBtn edit-name-btn"
                              onClick={handleTypeEditSave}
                            >
                              Save
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="orgInfoRow">
                    <div className="orgInfoCol"><label>Size:</label></div>
                    <div className="orgInfoCol">
                      <p>
                        {org.size === "SMALL"
                          ? "Small"
                          : org.size === "MEDIUM"
                            ? "Medium"
                            : org.size === "MICRO"
                              ? "Micro"
                              : org.size === "LARGE"
                                ? "Large"
                                : ""}
                      </p>
                    </div>
                  </div>
                  <div className="orgInfoRow">
                    <div className="orgInfoCol"><label>Category:</label></div>
                    <div className="orgInfoCol">
                      <p>
                        {org?.sectorsOutputs?.sectorOutput?.name || ""}
                      </p>
                    </div>
                  </div>
                  <div className="orgInfoRow">
                    <div className="orgInfoCol"><label>Subcategory:</label></div>
                    <div className="orgInfoCol">
                      <p>
                        {org?.sectorsOutputs?.subSectorOutput?.name || ""}
                      </p>
                    </div>
                  </div>
                  <div className="orgInfoRow">
                    <div className="orgInfoCol"><label>Full member:</label></div>
                    <div className="orgInfoCol"><Switch loading={loadingMemberSwitch} checked={org.isActiveMember === true} onChange={() => { toggleMemberType(org.isActiveMember) }} /></div>
                  </div>
                </div>
                <div className="orgDetailsCol">
                  <div className="orgInfoRow">
                    <div className="orgInfoCol"> <label>Website:</label></div>
                    <div className="orgInfoCol"><p title={org?.websiteLink ? <a href={org.websiteLink} target="_blank" rel="noreferrer">{truncate(org.websiteLink)}</a> : ""}>{org?.websiteLink ? <a href={org.websiteLink} target="_blank" rel="noreferrer">{truncate(org.websiteLink)}</a> : ""}</p></div>
                  </div>
                  <div className="orgInfoRow">
                    <div className="orgInfoCol"> <label>Email:</label></div>
                    <div className="orgInfoCol"><p title={org?.email ? org.email : ""}>{org?.email ? org.email : ""}</p></div>
                  </div>
                  <div className="orgInfoRow">
                    <div className="orgInfoCol"><label>Phone:</label></div>
                    <div className="orgInfoCol"> <p>{org.phone ? org.phone : ""}</p></div>
                  </div>
                  <div className="orgInfoRow">
                    <div className="orgInfoCol"><label>Address:</label></div>
                    <div className="orgInfoCol"><p title={org.addressOutputs[0]?.street
                      ? org.addressOutputs[0]?.street
                      : ""}>
                      {org.addressOutputs[0]?.street
                        ? org.addressOutputs[0]?.street
                        : ""}
                    </p></div>
                  </div>

                </div>
              </div>
            </div>

          </div>}
          <Divider className="org-details-divider" />
          <div className="microsite-previews">
            <div className="microsite-preview-header">
              <p>Sites ({microsites?.length})</p>
            </div>
            {!micrositesLoading ? (
              microsites?.length >= 1 ? (
                <div className="microsites-list">
                  {microsites.map((microsite) => (
                    <div className="microsite">
                      <div className="microsite-name">
                        <p>{microsite.name}</p>
                      </div>
                      <div className="microsite-preview">
                        {/* {microsite.isPublished ? (
                          <Button
                            className="microsite-preview-btn"
                            onClick={() => handlePreview(microsite.id)}
                          >
                            View Site
                          </Button>
                        ) : (
                          <Button
                            className="microsite-preview-btn disables"
                            disabled
                          >
                            View Site
                          </Button>
                        )} */}
                        <Button
                          className="microsite-preview-btn publish-btn"
                          onClick={() => {
                            if (microsite.isPublished) {
                              handleUnpublish(microsite);
                            } else {
                              handlePublish(microsite);
                            }
                          }}
                        >
                          {microsite.isPublished ? "Unpublish" : "Publish"}
                        </Button>

                          <Button
                          className={`microsite-preview-btn publish-btn ${microsite.isPublished ? '' : 'disables'}`}
                          style={{
                            padding:'0'
                          }}
                          disabled={!microsite.isPublished}
                          onClick={() => {
                             window.open(`${getMicrositeUrl(partnername)}/microsite/${microsite.name}?partnerId=${partnerID}&partnerName=${encodeURIComponent(partnername)}&interestName=${tabInterestName}`, '_blank');
                          }}
                        >
                          <Tooltip placement="top" title={microsite.isPublished ? '' : 'Publish the organisation to enable preview'}>
                            <span style={{
                            display: 'flex',
                            justifyContent:'center',
                            alignItems:'center',
                            width: '100%',
                            height: '100%'
                          }}>Preview</span>
                          </Tooltip>
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="no-microsites">
                  <p>No sites available</p>
                </div>
              )
            ) : (
              <div className="data-loader" style={{ marginTop: "0px" }}>
                <Spin className="spin" tip="Loading" size="large" />
              </div>
            )}
          </div>
          <Divider className="org-details-divider" />
          <div className="microsite-reviews">
            <div className="microsite-reviews-header">
              <p>Reviews</p>
            </div>
            {loadingReviews ? <div className="data-loader" style={{ marginTop: "0px" }}>
              <Spin className="spin" tip="Loading" size="large" />
            </div> : <div className="reviews-container">
              {reviews &&
                reviews.map((review) => (
                  <div className="review">
                    <div className="review-intro">
                      <div className="microsite-name">
                        {review.micrositeName}
                      </div>
                    </div>
                    <div className="review-message">
                      <div className="rating">
                        <Rate
                          className="ratings"
                          allowHalf
                          value={review.rating}
                          disabled
                        />
                        <div className="date">{formatDate(review.date)}</div>
                      </div>
                      <div className="message">{review.description}</div>
                    </div>
                  </div>
                ))}
              {
                (!reviews || reviews.length === 0) && <div className="no-microsites">
                  <p>No reviews available</p>
                </div>
              }
            </div>}
          </div>
        </div>
      </div>
      <Modal
        className="confirmation-modal"
        footer={null}
        open={unpublishConfirmationModal}
        onCancel={() => setUnpublishConfirmationModal(false)}
        destroyOnClose={true}
        closable={false}
      >
        <div className="message">
          <p>Are you sure you want to unpublish the site?</p>
        </div>
        <div className="modalBtns">
          <Button
            label="No"
            className="cancel-btn"
            onClick={() => setUnpublishConfirmationModal(false)}
          >
            Cancel
          </Button>
          <Button
            label="Yes"
            className="confirm-btn"
            onClick={() => unPublishMicrosite("unpublish")}
          >
            Yes
          </Button>
        </div>
      </Modal>
      <Modal
        className="confirmation-modal"
        footer={null}
        open={publishConfirmationModal}
        onCancel={() => setPublishConfirmationModal(false)}
        destroyOnClose={true}
        closable={false}
      >
        <div className="message">
          <p>Are you sure you want to publish the site?</p>
        </div>
        <div className="modalBtns">
          <Button
            label="No"
            className="cancel-btn"
            onClick={() => setPublishConfirmationModal(false)}
          >
            Cancel
          </Button>
          <Button
            label="Yes"
            className="confirm-btn"
            onClick={() => unPublishMicrosite("publish")}
          >
            Yes
          </Button>
        </div>
      </Modal>
      {selectedMicrositeId && previewModal ? (
        <Preview
          micrositeId={selectedMicrositeId}
          RemoveMicrosite={RemoveMicrosite}
        />
      ) : (
        <></>
      )}
    </>
  );
}
